import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/.well-known/mcp/server-card.json/")({});